import API from 'aurora-api';
import * as urls from 'aurora-api/urls';
import { ACTIVE_URL } from 'aurora-utils/constants';

const { BASE_URL } = ACTIVE_URL;

const api = new API(BASE_URL);

class constantService {
  static fetchCountries = () => api.get(urls.CONSTANT.FETCH_COUNTRIES);

  static fetchBanks = () => api.get(urls.CONSTANT.FETCH_BANKS);
}

export default constantService;
